var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Artboard"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("rect", { stroke: "#2D9F86", fill: "#6BC1B6", x: ".5", y: ".5", width: "19", height: "19", rx: "4" }),
      React.createElement("path", { fill: "#FFF", fillRule: "nonzero", d: "M14.5 5.5L16 7l-6.99 7L4.5 9.5 6 8l3.01 3z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/checkboxChecked.svg